<div #container class="agpr-sliderInput" role="group" [attr.aria-labelledby]="ariaLabelledBy">
    <agpr-button
        *ngIf="leftIcon"
        [id]="id + '_left'"
        class="agpr-sliderInput-leftIcon"
        [style]="buttonTypes.icon"
        [icon]="leftIcon"
        [tooltip]="leftTooltip"
        tooltipPosition="top"
        (click)="valueMin()"
    >
    </agpr-button>

    @if (showMinMaxLabels) {
        <div class="agpr-sliderInput-minMaxLabel">
            <span class="agpr-sliderInput-min">{{ min + '%' }}</span>
        </div>
    }

    <div class="agpr-sliderInput-slider">
        <agpr-slider
            [id]="id"
            [(ngModel)]="value"
            (ngModelChange)="valueChange($event)"
            [min]="min"
            [max]="max"
            [step]="step"
            [showValue]="showValue"
            [ariaValueText]="ariaValueText"
        ></agpr-slider>
    </div>
    <agpr-button
        *ngIf="rightIcon"
        [id]="id + '_right'"
        class="agpr-sliderInput-rightIcon"
        [style]="buttonTypes.icon"
        [icon]="rightIcon"
        [tooltip]="rightTooltip"
        tooltipPosition="top"
        (click)="valueMax()"
    >
    </agpr-button>

    @if (showMinMaxLabels) {
        <div class="agpr-sliderInput-minMaxLabel">
            <span class="agpr-sliderInput-min">{{ max + '%' }}</span>
        </div>
    }
</div>
